import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { MssRequestStatus } from '@services/dtos'
import { setMssRequestFilters } from '@state/reducers/mssReducer'
import { MssRequestStatusLabels } from '@utils/constants'

const MssRequestsTableToolbar = () => {
  const dispatch = useAppDispatch()
  const { filters } = useAppSelector(({ mss }) => ({
    filters: mss.requestFilters,
  }))

  return (
    <div className="ml-6 mt-4 flex items-center flex-wrap">
      <FormControl size="small" className="ml-6">
        <InputLabel>Statut</InputLabel>
        <Select
          value={filters.status}
          onChange={(ev: SelectChangeEvent<string>) =>
            dispatch(
              setMssRequestFilters({
                status: !ev.target.value
                  ? undefined
                  : (ev.target.value as MssRequestStatus),
              }),
            )
          }
          style={{
            minWidth: '120px',
            marginRight: 6,
          }}
          size="small"
        >
          <MenuItem value="">
            <em>Tous</em>
          </MenuItem>
          {Object.entries(MssRequestStatusLabels).map(([value, label]) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default MssRequestsTableToolbar
